import React, { useEffect, useState } from 'react'
import { Breadcrumb, Card, Container } from 'react-bootstrap'
import DatasourceForm from '../../components/forms/DatasourceForm'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Datasource } from '../../models/Datasource';
import { Datasources } from '../../api/Datasources';
import { useToasts } from '../../contexts/toasts';
import { useFullScreenLoader } from '../../contexts/fullScreenLoader';
import AppLoader from '../../components/common/AppLoader';
import { Helmet } from 'react-helmet';
import { Alert } from 'antd';

export default function DatasourceEdit() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [datasource, setDatasource] = useState<Datasource>();
  const [error, setError] = useState(false);

  const { showToast } = useToasts();
  const { showLoader, hideLoader } = useFullScreenLoader();

  useEffect(() => {
    if (id) initDatasource();
    else setDatasource(new Datasource());
    // eslint-disable-next-line
  }, []);

  const initDatasource = () => {
    Datasources.getDatasource(+id!)
      .then(
        ({ data: ds }) => setDatasource(ds),
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('datasources-error', message, `Data Source Error ${status ? `(${status})` : ''}`, 'danger');
          setError(true);
        }
      )
  }

  const onCancel = () => navigate("/datasources");

  const onSubmit = (datasource: Datasource) => {
    showLoader();

    Datasources.createDatasource(datasource)
      .then(
        ({ data: newDatasource }) => {
          hideLoader();
          showToast('submit-datasource-success', `Data Source "${newDatasource.name}" ${id ? "updated" : "created"} successfully`, `Data Source ${id ? "Updated" : "Created"}`, 'success');
          navigate(`/datasources/${newDatasource.id}`);
        },
        () => {
          hideLoader();
          showToast('submit-datasource-error', 'Could not get create data source.', 'Data Source Error', 'danger');
        }
      )
  }

  const renderAsyncContent = () => {
    if (error) return (
      <Alert
        showIcon
        type="error"
        message="An error occured during data source retrieve. Try again later"
      />
    )

    return datasource
      ? <DatasourceForm datasource={datasource} onSubmit={onSubmit} onCancel={onCancel} />
      : (
        <div className="d-flex justify-content-center py-5">
          <AppLoader size={300} />
        </div>
      );
  }

  return (
    <Container className="my-3">
      <Helmet>
        <title>Data Source {id ? `${id} Edit` : "Registration"}</title>
      </Helmet>

      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/datasources' }}>Data Sources</Breadcrumb.Item>
        <Breadcrumb.Item active>{id ? (datasource?.name || 'Datasource') + ' Edit' : 'New Data Source'}</Breadcrumb.Item>
      </Breadcrumb>

      <Card>
        <Card.Header className="bg-white">
          <h5>{id ? (datasource?.name || "Datasource") + " Edit" : "New Data Source"}</h5>
          <h6 className="mb-0 text-muted">Fill in {id ? "new" : "existing"} data source details</h6>
        </Card.Header>
        <Card.Body>
          {renderAsyncContent()}
        </Card.Body>
      </Card>
    </Container>
  )
}
